import { Directive, forwardRef, Attribute } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appRequiredIf][formControlName]',
  providers: [
      { provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredIfDirective), multi: true }
  ]
})
export class RequiredIfDirective {
    constructor(@Attribute('appRequiredIf') public requiredFieldName: string) {}
    
    validate(c: AbstractControl): { [key: string]: any } {
        const e = c.root.get(this.requiredFieldName);
        if (e && e.value && !c.value) {return {
            appRequiredIf: false
        };}
        return null;
    }
}